import { readApiJson } from "./apiResponse";

// Fetch the complete authorized collection independently of table pagination,
// search, selected filters, and active stats. Honor server-side page-size caps.
export async function loadFilterRecords(endpoint, { signal } = {}) {
  const base = String(process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
  const token = ["token", "authToken", "jwt", "accessToken", "access_token"]
    .map((key) => localStorage.getItem(key) || sessionStorage.getItem(key)).find(Boolean);
  const records = [];
  const seenIds = new Set();
  for (let page = 1; ; page += 1) {
    const [path, search = ""] = endpoint.split("?");
    const query = new URLSearchParams(search);
    query.set("page", String(page));
    query.set("limit", "100");
    if (!query.has("sort")) query.set("sort", "id");
    if (!query.has("order")) query.set("order", "asc");
    const response = await fetch(`${base}${path}?${query}`, {
      credentials: "include", signal,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    const payload = await readApiJson(response, "Filter options");
    const batch = Array.isArray(payload) ? payload
      : payload.rows ?? payload.data ?? payload.items ?? payload.candidates;
    if (!Array.isArray(batch)) throw new Error("Filter options returned an invalid record list.");
    const total = payload.total == null ? NaN : Number(payload.total);
    const reportedPages = payload.totalPages ?? payload.total_pages;
    const totalPages = reportedPages == null ? NaN : Number(reportedPages);
    const pageSize = Number(payload.limit) || 100;
    if (!batch.length) {
      if ((Number.isFinite(total) && records.length < total) || page < totalPages) {
        throw new Error("The record list changed while loading filter options. Reopen filters to retry.");
      }
      return records;
    }
    let added = 0;
    batch.forEach((row) => {
      if (row.id != null && seenIds.has(String(row.id))) return;
      if (row.id != null) seenIds.add(String(row.id));
      records.push(row);
      added += 1;
    });
    if (!added) throw new Error("Could not load every page of filter options. Reopen filters to retry.");
    if (Array.isArray(payload)) return records;
    if (Number.isFinite(total)) {
      if (records.length >= total) return records;
    } else if (Number.isFinite(totalPages)) {
      if (page >= totalPages) return records;
    } else if (batch.length < pageSize) return records;
  }
}
